import { useState, type FormEvent } from 'react';
import { ApiError } from '../../lib/api';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { FormField } from '../../components/ui/FormField';

export function CredentialsForm({ onSubmit }: { onSubmit: (email: string, password: string) => Promise<void> }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    setPending(true);
    try {
      await onSubmit(email, password);
    } catch (err) {
      if (err instanceof ApiError && err.code === 'IP_NOT_ALLOWED') {
        setError('Your IP address is not allowed for this operator console. Contact support.');
      } else {
        setError(err instanceof Error ? err.message : 'Login failed');
      }
    } finally {
      setPending(false);
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full max-w-sm rounded-xl border border-[var(--co-border)] bg-[var(--co-surface)] p-6 shadow-sm flex flex-col gap-4"
      noValidate
    >
      <header className="mb-2">
        <h1 className="text-xl font-semibold">Operator Console</h1>
        <p className="text-sm text-[var(--co-muted)]">Sign in to manage your operator.</p>
      </header>
      <FormField label="Email" htmlFor="login-email">
        <Input id="login-email" type="email" autoComplete="email" required value={email}
               onChange={(e) => setEmail(e.target.value)} />
      </FormField>
      <FormField label="Password" htmlFor="login-password" error={error ?? undefined}>
        <Input id="login-password" type="password" autoComplete="current-password" required value={password}
               onChange={(e) => setPassword(e.target.value)} />
      </FormField>
      <Button type="submit" disabled={pending}>
        {pending ? 'Signing in…' : 'Sign in'}
      </Button>
    </form>
  );
}
